import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { EventDetailsEntity } from './event-details.entity';

@Injectable()
export class EventDetailsService {
    constructor(
        @InjectRepository(EventDetailsEntity)
        private eventDetailsRepo:Repository<EventDetailsEntity>,
        
    ){}

    async createGuestUsers(dataToPost) {
        const saveData = await this.eventDetailsRepo.save(dataToPost);
        if(saveData) {
            return true;
        } else {
            return null;
        }
    }

    async deleteGuestUsers(eventId) {
        const del = await this.eventDetailsRepo.delete({eventId:eventId})
        if(del) {
            return true;
        } else {
            return null;
        }
    }
}
